document.addEventListener("DOMContentLoaded", () => {
  const timelineItems = document.querySelectorAll(".timeline-item");

  if (!timelineItems.length) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const line = entry.target.querySelector(".timeline--line");
        if (!line) return;

        if (entry.isIntersecting) {
          line.classList.add("fill");
        } else {
          // remove to not repeat animation
          line.classList.remove("fill");
        }
      });
    },
    {
      // block part to be visible to work
      threshold: 1,
    }
  );

  timelineItems.forEach((item) => observer.observe(item));
});
